import {Button} from '@material-ui/core';
import {Ballot, CheckCircleOutline, MoodBad} from '@material-ui/icons';
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';

import {useLocation} from 'react-router';
import {pushRoute} from '../../routes';
import DetachedIcon from '../../shared/components/detachedIcon';
import RollerLoading from '../../shared/components/rollerLoading';
import {getUrlShareReceipt} from '../../shared/helpers/getApiFromLocation';
import {getUser} from '../auth/store/selectors';
import ReceiptDialog from '../election/components/ReceiptDialog';
import Screen from '../election/screen';
import {getElection} from '../election/store/selectors';
import {eSingleClearData} from './store/actions';
import {getESingleInfo, getESingleVoteResult} from './store/selectors';
import {ISingleVoting} from './store/types';

const SingleResultVoting: React.FC = () => {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const {loading} = useSelector(getESingleInfo);
  const resultVoting: ISingleVoting[] = useSelector(getESingleVoteResult);
  const election = useSelector(getElection);
  const [openReceipt, setOpenReceipt] = useState<boolean>(false);
  const [timeDelay, setTimeDelay] = useState<number>();
  const user = useSelector(getUser);
  const userId = user && user.id ? user.id.toString() : '';
  const queryParams = new URLSearchParams(useLocation().search);
  const locale =
    queryParams.get('locale') ||
    localStorage.getItem('SEI_POCKET_LOCALE') ||
    'pt';

  useEffect(() => {
    setOpenReceiptSession(openReceipt);
  }, [openReceipt]);

  useEffect(() => {
    if (!loading && resultVoting) {
      return redirectAfterTime(8000);
    }
  }, [resultVoting, loading]);

  const redirectToHome = () => {
    dispatch(pushRoute('home'));
  };

  const redirectAfterTime = (ms = 8000) => {
    clearDelay();

    const timer: number = (setTimeout(() => {
      redirectTo();
    }, ms) as unknown) as number;

    setTimeDelay(timer);
  };

  const getOpenReceiptSession = (): boolean => {
    return window.sessionStorage.getItem('openReceipt') === 'true';
  };

  const setOpenReceiptSession = (open: boolean): void => {
    window.sessionStorage.setItem('openReceipt', open ? 'true' : 'false');
  };

  const clearDelay = () => {
    if (timeDelay) {
      clearTimeout(timeDelay);
      setTimeDelay(undefined);
    }
  };

  const redirectTo = () => {
    const openReceiptSession = getOpenReceiptSession();
    clearDelay();

    if (openReceiptSession) {
      return;
    }

    dispatch(eSingleClearData());
    redirectToHome();
  };

  const makeUrl = (): string => {
    const receiptList = resultVoting.map(result => result.receipt);
    const receiptUlr = receiptList.join('+');

    return resultVoting.length > 0
      ? getUrlShareReceipt(receiptUlr, locale, userId)
      : '#';
  };

  const closeDialog = () => {
    setOpenReceipt(false);
    redirectAfterTime(3000);
  };

  return (
    <Screen className="result loading screen-justify-start-padding pb-60 ">
      {/*LOADING*/}
      {loading && (
        <>
          <RollerLoading color="orange" />
          <h2 className="primary-title">
            {t('resultado-votacao-simples.aguarde')}
          </h2>
          <p className="default-subtitle">
            {t('resultado-votacao-simples.computando-voto')}
          </p>
        </>
      )}

      {/*SUCCESS*/}
      {!loading &&
        resultVoting &&
        Array.isArray(resultVoting) &&
        resultVoting.length > 0 && (
          <>
            <DetachedIcon
              size="lg"
              color="green"
              icon={<CheckCircleOutline />}
            />
            <br />
            <h2 className="sucess-text">
              {t('resultado-votacao-simples.sucesso')}
            </h2>
            <p className="default-subtitle text-center">
              {t('resultado-votacao-simples.contabilizado-com-sucesso')} <br />
              {t('resultado-votacao-simples.aguarde-redirecionamento')}
            </p>

            {election && election.configs.show_receipt_view && (
              <>
                <Button
                  className={`full-width `}
                  type="button"
                  color="primary"
                  onClick={() => setOpenReceipt(true)}
                  startIcon={<Ballot />}
                  style={{marginBottom: '30px'}}
                >
                  {t('resultado-votacao.ver-comprovante')}
                </Button>

                <br />
                <br />

                <ReceiptDialog
                  receiptUrl={makeUrl()}
                  open={openReceipt}
                  onClose={closeDialog}
                />
              </>
            )}
          </>
        )}

      {/*ERROR*/}
      {!loading && (!resultVoting || resultVoting.length === 0) && (
        <>
          <DetachedIcon size="lg" color="red" icon={<MoodBad />} />
          <br />
          <h2 className="error-text text-center">
            {t('resultado-votacao-simples.erro-ao-votar')}
          </h2>

          <br />
          <p className="default-subtitle text-center">
            {t('resultado-votacao-simples.erro-ao-votar-mensagem')}
          </p>
          <br />
          <Button
            className={`full-width mb-24 `}
            type="button"
            color="primary"
            onClick={redirectToHome}
            variant="contained"
          >
            {t('resultado-votacao-simples.tentar-novamente')}
          </Button>
        </>
      )}
    </Screen>
  );
};

export default SingleResultVoting;



// WEBPACK FOOTER //
// ./src/features/election-single/SingleResultVoting.tsx